<div class="panel-matrix">
  <div
    class="panel-matrix__header"
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="panelDef?.color"
  >
    <span
      *ngIf="!ui.editMode; else editModeTitle"
      class="panel-matrix__header__title"
      [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
    >
      {{ panelDef.title }}
    </span>
    <ng-template #editModeTitle>
      <div class="panel-matrix__header__title-edit">
        <mat-form-field>
          <input matInput [formControl]="title" placeholder="Panel title" autocomplete="off" />
        </mat-form-field>
      </div>
    </ng-template>
    <div class="panel-matrix__header__actions">
      @if ((pendingChanges() | keyvalue).length) {
        <ts-button [disabled]="savingChanges()" type="stroked" color="accent" (click)="discardChanges()" class="mr-2"
          >Discard
        </ts-button>
        <ts-button [loading]="savingChanges()" (click)="saveChanges()" [debounceTime]="500">Save changes </ts-button>
      }
      <ts-button
        icon="history"
        class="mr-2"
        type="icon"
        color="basic"
        iconColor="gray"
        [tsOverlayTriggerFor]="filtersOverlayBox"
      >
      </ts-button>

      <button
        *ngIf="!ui.editMode && panelDefFieldsLength && !newTable()"
        class="mr-2"
        mat-icon-button
        type="button"
        (click)="toggleCellsWidth()"
        [matTooltip]="isFullWidth() ? 'Collapse cells' : 'Expand cells'"
      >
        <ts-icon
          [icon]="isFullWidth() ? 'ts_collapse-content' : 'ts_expand-content'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></ts-icon>
      </button>

      <button mat-icon-button type="button" *ngIf="!ui.editMode" [matMenuTriggerFor]="moreMenu">
        <mat-icon
          class="icon-size-20"
          [svgIcon]="'more_vert'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>
      <mat-menu #moreMenu>
        <button mat-menu-item (click)="toggleEditMode()" type="button" [appAuthorize]="!readonly" denyAction="disable">
          <mat-icon svgIcon="edit"></mat-icon>
          Edit Layout
        </button>
        <ng-container *ngIf="relatedToType === relatedToTypeEnum.Project">
          <button
            mat-menu-item
            [matMenuTriggerFor]="toggleLabelMenu"
            type="button"
            [appAuthorize]="!readonly"
            denyAction="disable"
          >
            <mat-icon [svgIcon]="'color_lens'"></mat-icon>
            Heading Color
          </button>
          <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
            <div
              mat-menu-item
              class="gap-2"
              *ngFor="let color of accountColors$ | async"
              (click)="selectHeaderColor(color.name)"
            >
              <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
              {{ color.label }}
            </div>
          </mat-menu>
        </ng-container>
        <button *ngIf="panelDef.meta.showFooter" mat-menu-item (click)="toggleFooter()" type="button">
          <mat-icon>visibility_off</mat-icon>
          Hide Sum/Avg
        </button>
        <button *ngIf="!panelDef.meta.showFooter" mat-menu-item (click)="toggleFooter()" type="button">
          <mat-icon>visibility</mat-icon>
          Show Sum/Avg
        </button>
        <button [appAuthorize]="hasSharingPermission()" mat-menu-item (click)="exportMatrix()" type="button">
          <mat-icon>download</mat-icon>
          Export
        </button>
      </mat-menu>
      <div class="panel-matrix__header__actions__layout" *ngIf="ui.editMode">
        <button mat-icon-button type="button" matTooltip="Cancel" (click)="cancelEdits()">
          <mat-icon
            [svgIcon]="'cancel'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="saveLayout()" matTooltip="Save">
          <mat-icon
            [svgIcon]="'save'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="panel-matrix__body">
    <ng-container *ngIf="!isEmpty; else empty">
      @if (newTable() && !ui.editMode) {
        <ts-table
          [cellDataType]="false"
          [gridOptions]="gridOptions"
          [relatedToRedirectConfig]="relatedToRedirectConfig"
          [columnDefs]="columnDefs"
          [rowData]="rowData"
          [data]="data"
          (gridReady)="onGridReady($event)"
          [readOnly]="!hasEditPermission()"
          [autoSizeAllColumns]="true"
        ></ts-table>
      }
      @if (!newTable() || (ui.editMode && newTable())) {
        <table class="table-container" [style.width]="isFullWidth() ? 'max-content' : 'auto'">
          <thead>
            <tr
              cdkDropList
              cdkDropListOrientation="horizontal"
              [cdkDropListData]="panelDefColumns"
              (cdkDropListDropped)="dropColumns($event)"
            >
              <th
                *ngFor="let column of panelDefColumns; let columnIndex = index"
                [class.sticky-column]="columnIndex === 0"
                cdkDrag
                [cdkDragDisabled]="!isColumnDraggable(columnIndex) || !ui.editMode"
              >
                <ng-container *ngIf="!ui.editMode; else headerEditMode">
                  <span class="column-label">{{ columnIndex > 0 ? column : null }}</span>
                </ng-container>
                <ng-template #headerEditMode>
                  <div class="flex items-center">
                    <button
                      *ngIf="columnIndex > 0"
                      mat-icon-button
                      (click)="manageColumn('remove', columnIndex)"
                      matTooltip="Remove Column"
                    >
                      <mat-icon>cancel</mat-icon>
                    </button>
                    <button *ngIf="columnIndex > 0" mat-icon-button cdkDragHandle class="drag-handle">
                      <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                    </button>
                    <input
                      *ngIf="columnIndex > 0"
                      [formControl]="columnControls[columnIndex]"
                      placeholder="Column Label"
                      class="ml-2 w-full"
                      (change)="updateColumnName(columnIndex)"
                    />
                    <button
                      *ngIf="panelDefColumnsLength - 1 === columnIndex"
                      mat-icon-button
                      (click)="manageColumn('add')"
                      matTooltip="Add New Column"
                      class="ml-2"
                    >
                      <mat-icon svgIcon="add_circle"></mat-icon>
                    </button>
                  </div>
                </ng-template>
              </th>
            </tr>
          </thead>

          <tbody cdkDropList [cdkDropListData]="panelDefFields" (cdkDropListDropped)="dropRows($event)">
            <tr *ngFor="let row of panelDefFields; let rowIndex = index" cdkDrag [cdkDragDisabled]="!ui.editMode">
              <td *ngFor="let column of panelDefColumns; let columnIndex = index">
                <ng-container *ngIf="!ui.editMode; else cellEditMode">
                  <ng-container *ngIf="columnIndex > 0; else rowLabelRead">
                    <ng-container *ngIf="lookupField(panelDefFields[rowIndex][columnIndex]) as fieldDef">
                      <app-editable
                        [fieldDef]="fieldDef"
                        [model]="model"
                        [data]="data"
                        (onUpdate)="update($event)"
                        [readonly]="!hasEditPermission()"
                      >
                      </app-editable>
                    </ng-container>
                  </ng-container>
                  <ng-template #rowLabelRead>
                    <span class="row-label">{{ panelDefFields[rowIndex][columnIndex] }}</span>
                  </ng-template>
                </ng-container>
                <ng-template #cellEditMode>
                  <ng-container *ngIf="columnIndex > 0; else rowLabel">
                    <ng-container *ngIf="lookupField(panelDefFields[rowIndex][columnIndex], true) as fieldDef">
                      <select-field
                        [data]="{ fieldDefs }"
                        class="flex flex-col select-field"
                        [fieldDef]="fieldDef"
                        [model]="panelDef"
                        [rowIndex]="rowIndex"
                        [colIndex]="columnIndex"
                      >
                      </select-field>
                    </ng-container>
                  </ng-container>
                  <ng-template #rowLabel>
                    <div class="flex items-center">
                      <button mat-icon-button (click)="manageRow('remove', rowIndex)" matTooltip="Remove Row">
                        <mat-icon>cancel</mat-icon>
                      </button>
                      <button mat-icon-button *ngIf="ui.editMode" cdkDragHandle>
                        <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
                      </button>
                      <input
                        placeholder="Row Label"
                        type="text"
                        class="ml-2 w-full"
                        [formControl]="rowControls[rowIndex]"
                        (change)="updateRowName(rowIndex, columnIndex)"
                      />
                    </div>
                  </ng-template>
                </ng-template>
              </td>
            </tr>

            <tr class="footer-row" [class.display-none]="!ui.editMode">
              <td [attr.colspan]="panelDefColumnsLength" class="footer-cell">
                <button *ngIf="ui.editMode" mat-icon-button (click)="manageRow('add')" matTooltip="Add New Row">
                  <mat-icon svgIcon="add_circle"></mat-icon>
                </button>
              </td>
            </tr>

            <tr class="summary-row" *ngIf="!ui.editMode && panelDef.meta.showFooter">
              <td *ngFor="let column of panelDefColumns; let columnIndex = index">
                <div class="summary-cell" *ngIf="columnIndex > 0">
                  <span>
                    <strong>{{ panelDef.meta.footer[columnIndex] ?? 'Sum' | titlecase }}</strong
                    >:
                    {{ getAggValue(columnIndex) }}
                  </span>
                  <button
                    [matMenuTriggerFor]="actionsMenu"
                    mat-icon-button
                    class="z-0"
                    matTooltip="Toggle Sum/Avg"
                    [appAuthorize]="hasEditPermission()"
                  >
                    <mat-icon [svgIcon]="'expand_more'" class="icon-size-12"></mat-icon>
                  </button>
                  <mat-menu #actionsMenu="matMenu">
                    <button
                      mat-menu-item
                      (click)="toggleAgg(columnIndex, 'sum')"
                      [appAuthorize]="hasEditPermission()"
                      denyAction="disable"
                    >
                      <span class="ml-2">Sum</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="toggleAgg(columnIndex, 'avg')"
                      [appAuthorize]="hasEditPermission()"
                      denyAction="disable"
                    >
                      <span class="ml-2">Average</span>
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      }
    </ng-container>
  </div>
</div>

<ng-template #empty>
  <div class="panel-matrix__body__empty flex flex-col items-center justify-center h-full">
    <mat-icon class="icon-size-40">table_chart</mat-icon>
    <p class="text-2xl text-secondary font-medium mt-4">No data to show</p>
    <p class="panel-matrix__body__empty__message text-sm text-secondary mt-2" *ngIf="hasEditPermission()">
      <mat-icon>lightbulb_outline</mat-icon>
      Start adding data by clicking&nbsp;<a (click)="toggleEditMode()">here</a>.
    </p>
  </div>
</ng-template>

<ts-overlay
  #filtersOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onCloseByBackdropClick()"
  (opened)="onOpened()"
>
  @if (historyOpen()) {
    <div class="history-overlay">
      <div class="history">
        <app-field-history
          [model]="model"
          [data]="data"
          [relatedToType]="relatedToType"
          [multiFields]="true"
          [fieldDef]="layoutFieldDefs | async"
        ></app-field-history>
      </div>
    </div>
  }
</ts-overlay>
